<template>
  <div class="recommend" ref="recommend">
    <div class="left_fix">
      <img src="https://static.vivl1.com/gqj_live/image/recommend/left_btn.png" alt @click="ADqrcode = !ADqrcode"
        width="10px" />
      <img src="https://static.vivl1.com/gqj_live/image/recommend/indicate.png" alt width="102px"
        @click="ADqrcode = !ADqrcode" />
      <br />
    </div>
    <div class="ADqrcode">
      <img src="//static.vivl1.com/gqj_tv/ADqrcode.png" alt width="170px"
        :class="ADqrcode ? 'qrcodeshow' : ADqrcode === 0 ? '' : 'qrcodehide'"
        :style="ADqrcode ? 'margin-left: 0px;' : 'margin-left: -170px;'" />
    </div>
    <div class="box">
      <div class="video">
        <div class="novideo" v-show="novideo">视频已下架，请选其他视频观看！</div>
        <div class="sub_list">
          <img src="https://static.vivl1.com/gqj_live/image/recommend/video_banner.png?v1" alt width="100%"
            ref="video_banner" />
        </div>
        <div class="sub_box" @mouseenter="titleshow = true" @mouseleave="titleshow = false">
          <div :class="titleshow ? 'title titleshow' : titleshow === 0 ? 'title' : 'title titlehide'"
            :style="titleshow ? 'top:0px;' : 'top:-50px;'">{{ detail.title }}</div>
          <iframe class="sub_player" name="myplayer" id="iframe2" scrolling="no" webkitallowfullscreen="true"
            mozallowfullscreen="true" allowfullscreen="true" :src="player"></iframe>
          <!--<div class="sub_barrier">
						赛事已完场
          </div>-->
        </div>
      </div>
    </div>
    <div class="tvlines" v-show="more.length > 1" style="width:60%;">
      <div class="tv_title">
        <span>往期回顾</span>
        <span @click="moreFn()" v-if="more.length > 5">
          查看更多
          <i class="iconfont2" :style="morenum > 5 ? 'transform: rotateX(180deg);' : ''">&#xe644;</i>
        </span>
      </div>
      <div class="tv_select">
        <div v-for="item, index in more" @click="tabCurrUrl(item, index)" v-if="index < morenum">
          <div class="face">
            <img :src="item.cover" />
            <div class="playing" v-if="item.tv_id == detail.tv_id">
              <span>观看中</span>
              <div class></div>
              <div class></div>
              <div class></div>
            </div>
          </div>
          <div class="tv_username" :title="item.title">{{ item.title }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
//	import SDK from "@/assets/js/NIM_Web_SDK_v7.0.0.js";
export default {
  name: "detail",
  data() {
    return {
      tv_id: this.$route.params.id,
      headCon: headCon(),
      detail: {
        tv_id: 12,
        title: "333",
        cover: "https://cdn.czsjl.cn/333.mp4?vframe/jpg/offset/20/w/285/h/160",
      },
      novideo: 0,
      more: [
        {
          tv_id: 12,
          title: "333",
          cover:
            "https://cdn.czsjl.cn/333.mp4?vframe/jpg/offset/20/w/285/h/160",
        },
        {
          tv_id: 12,
          title: "333",
          cover:
            "https://cdn.czsjl.cn/333.mp4?vframe/jpg/offset/20/w/285/h/160",
        },
        {
          tv_id: 12,
          title: "333",
          cover:
            "https://cdn.czsjl.cn/333.mp4?vframe/jpg/offset/20/w/285/h/160",
        },
      ],
      more_two: [],
      type: 0,
      toLogin: 0,
      player: "",
      morenum: 5,
      ADqrcode: 0,
      titleshow: 0,
    };
  },
  mounted() {
    var that = this;
    this.request();
    that.setPlayerH();
    window.onresize = function () {
      //当浏览器大小变化时,改变视频高度
      that.setPlayerH();
    };
  },
  beforeMount() {
    var wx_login_t = this.$route.query.wx_login_t;
    if (wx_login_t) {
      var href = location.href;
      if (location.href.indexOf("&") == -1) {
        href = href.replace("?wx_login_t=" + wx_login_t, "");
      } else {
        href = href.replace("&wx_login_t=" + wx_login_t, "");
        href = href.replace("wx_login_t=" + wx_login_t + "&", "");
      }
      history.pushState("", "", href);
    }
  },
  methods: {
    setPlayerH() {
      var div = document.getElementById("iframe2");
      var w = div.offsetWidth;
      var video_bannerH = this.$refs["video_banner"].height;
      //				if(w<840){
      var vH = (563 / 1000) * parseInt(w);
      div.style.height = vH + "px";
      div.parentNode.style.height = vH + "px";
      //				}else{
      //					div.style.height = 472.92+"px";
      //					div.parentNode.style.height = 472.92+"px";
      //					chat.style.height = 542+"px";
      //					dialog.style.height = 327+"px";
      //					dialog.parentNode.style.height = 341+"px";
      //					this.scroll_line = 327+"px";
      //				}
    },
    request() {
      var url = COMMOND.NEW_BASE_URL + "get_past_video/" + this.tv_id;
      axios.get(url).then((res) => {
        if (res.data.data.detail) {
          this.detail = res.data.data.detail;
        } else {
          this.novideo = 1;
          this.detail = {};
        }
        if (res.data.data.more) {
          this.more_two = [].concat(res.data.data.more);
          this.more = [].concat(res.data.data.more);
        } else {
          this.more = [];
        }
        if (this.detail.tv_id) {
          this.player = COMMOND.VIDEO_URL + this.detail.tv_id + "?type=1";
        }
        this.$nextTick(function () {
          $("footer").show();
        });
      });
    },
    moreFn() {
      if (this.morenum != 5) {
        this.morenum = 5;
      } else {
        this.morenum = this.more.length;
      }
    },
    tabCurrUrl(item, index) {
      this.chatsList = [];
      if (item.tv_id) {
        this.player = COMMOND.VIDEO_URL + item.tv_id + "?type=1";
      } else {
        return;
      }
      this.detail.cover = item.cover;
      this.detail.tv_id = item.tv_id;
      this.detail.title = item.title;
      this.detail.video_url = item.video_url;
      history.pushState("", "", "/zonghe/recommend/past/" + item.tv_id);
    },
  },
  metaInfo() {
    return {
      title: this.headCon["zonghe"]["title"],
      meta: [
        {
          hid: "keywords",
          name: "keywords",
          content: this.headCon["zonghe"]["keywords"],
        },
      ],
    };
  },
};
</script>
<style scoped="scoped">
@import "../../assets/css/recommend.css";

.box,
.tvlines {
  width: 60%;
}

.box .video {
  width: 100%;
}
</style>